import { StreamAPI } from "@/api/stable/APIStable"
import { mapRelease } from "@/api/stable/mappings/releases"

import { ReleasesSearchDTO } from "./releases.dto"
import { AppName, DownloadUrlResponse, Platform, Release, ReleasesListResponse } from "./releases.types"

import DAO from "../dao"

class ReleasesDAO extends DAO {
  async getLatestRelease(app: AppName, platform?: Platform): Promise<Release> {
    const response = await StreamAPI.fetch.GET["/releases/{app}/latest"]({
      pathParams: { app },
      queryParams: platform ? { platform } : undefined
    })

    const release = mapRelease(response.payload)
    return release
  }

  async getSpecificVersion(app: AppName, version: string): Promise<Release> {
    const response = await StreamAPI.fetch.GET["/releases/{app}/{version}"]({
      pathParams: { app, version }
    })

    const release = mapRelease(response.payload)
    return release
  }

  async listReleases(search?: ReleasesSearchDTO): Promise<ReleasesListResponse> {
    const response = await StreamAPI.fetch.GET["/releases"]({
      queryParams: { ...search }
    })

    return {
      data: response.payload.data.map(mapRelease),
      pagination: response.payload.pagination
    }
  }

  async getDownloadUrl(s3Key: string): Promise<DownloadUrlResponse> {
    const response = await StreamAPI.fetch.GET["/releases/download/{s3Key}"]({
      pathParams: { s3Key }
    })

    return {
      url: response.payload.url,
      expiresIn: response.payload.expiresIn,
      filename: response.payload.filename
    }
  }

  async getLatestDownloadUrl(app: AppName, platform: Platform = Platform.Windows): Promise<DownloadUrlResponse | null> {
    try {
      const release = await this.getLatestRelease(app, platform)

      const asset = release.assets.find(a => a.platform === platform)

      if (!asset) {
        console.warn(`No ${platform} asset found for ${app}`)
        return null
      }

      const downloadUrl = await this.getDownloadUrl(asset.s3Key)
      return downloadUrl
    } catch (error) {
      console.error(`Failed to get download URL for ${app}:`, error)
      return null
    }
  }
}

const ReleasesDao = new ReleasesDAO()
export default ReleasesDao
